import { AppRoute } from '@core/route-data/models/app-routes';
import { hasSummaryAccessGuard } from '@pages/report-card/guards/has-summary-access.guard';
import { hasMyCoursesAccessGuard } from '@pages/report-card/guards/has-my-courses-access.guard';
import { ReportCardTabPath } from '@pages/report-card/models/report-card-tab-path.enum';

export const reportCardRoutes: AppRoute[] = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: `${ReportCardTabPath.Learners}`,
    data: { prefetchTarget: `${ReportCardTabPath.Learners}` },
  },
  {
    path: `${ReportCardTabPath.Learners}`,
    canMatch: [hasSummaryAccessGuard],
    loadComponent: () =>
      import('@pages/report-card/components/learners-table/learners-table.component').then(
        ({ LearnersTableComponent }) => LearnersTableComponent
      ),
  },
  {
    path: `${ReportCardTabPath.Courses}`,
    canMatch: [hasSummaryAccessGuard],
    loadComponent: () =>
      import('@pages/report-card/components/courses-table/courses-table.component').then(
        ({ CoursesTableComponent }) => CoursesTableComponent
      ),
  },
  {
    path: `${ReportCardTabPath.MyCourses}`,
    canMatch: [hasMyCoursesAccessGuard],
    loadComponent: () =>
      import('@pages/report-card/components/my-courses-table/my-courses-table.component').then(
        ({ MyCoursesTableComponent }) => MyCoursesTableComponent
      ),
  },
];
